import { TranslateLoader } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { locales } from '../assets/i18n/locales';
import { LocalStorageService } from 'angular-2-local-storage';
import { storageKeys } from '../agility-risk.constants';
import { BrandingTerm } from '../models/branding-term';

export class AgilityCustomTranslateLoaderService implements TranslateLoader {

  constructor(private storage: LocalStorageService) {
  }

  public getTranslation(lang: string): Observable<any> {
    const translations = JSON.parse(JSON.stringify(locales[lang]));
    return of(this.mergeBrandingTerms(translations, lang));
  }

  private mergeBrandingTerms(translations: any, lang: string) {
    const termsForReplacement = this.storage.get(`${storageKeys.brandingTerms}.${lang}`) as Array<BrandingTerm>;
    if (termsForReplacement) {
      if (Array.isArray(termsForReplacement)) {
        termsForReplacement.forEach(terminology => {
          this.updateBrandingTerm(translations, terminology);
        });
        return translations;
      }
    } else {
      return translations;
    }
  }

  private updateBrandingTerm(translations: any, terminology: BrandingTerm): any {
    Object.keys(translations)
      .filter(key => {
        return typeof translations[key] === 'object' ||
          (!terminology.wholeWords && typeof translations[key] === 'string' && translations[key].match(new RegExp(terminology.searchFor, terminology.ignoreCase ? 'i' : '')));
      })
      .forEach((key: string) => {
        if (typeof translations[key] === 'object') {
          this.updateBrandingTerm(translations[key], terminology);
        } else {
          const regex = new RegExp(terminology.searchFor, terminology.ignoreCase ? 'ig' : 'g');
          translations[key] = translations[key].replace(regex, terminology.replaceWith);
        }
      });
  }
}
